export const FOB_TICKET_PLACED_BET_TYPE = 'Place - Fixed'
